export default __webpack_public_path__ + "static/media/ceraveRetinolSerum.ebfcc502.webp";